import React, { useState } from "react";
import Message from "./Message";
import ChatItem from "./ChatItem";
import "./Mid-Section.scss";
import { formatTimestamp, formatDate } from "./utils"; // Utility functions can be placed here
import { IoMdArrowBack } from "react-icons/io";
import TopSection from "../../OverView/Mobile-and-Tablet/Top-Section-Mobile";

const MobileChat = ({ setSharedValue, sharedValue }) => {
  const [messageInput, setMessageInput] = useState("");
  const [activeChat, setActiveChat] = useState(null); // Initially no chat is active
  const [chats, setChats] = useState([
    {
      user: "Landlord Walker",
      // profilePicture: 'https://example.com/profiles/allan.jpg',
      messages: [
        {
          text: "Hello! How are you?",
          type: "incoming",
          timestamp: "2024-08-24T09:30:00",
        },
        {
          text: "I am fine, thank you!",
          type: "outgoing",
          timestamp: "2024-08-24T09:35:00",
        },
      ],
    },
    {
      user: "Admin Hussain",
      profilePicture: "",
      messages: [
        {
          text: "Hey, any updates on the project?",
          type: "incoming",
          timestamp: "2024-08-24T10:00:00",
        },
        {
          text: "Yes, I have made some changes to the project plan and updated the timeline accordingly.",
          type: "outgoing",
          timestamp: "2024-08-24T10:05:00",
        },
      ],
    },
    {
      user: "Tenant Oliver",
      // profilePicture: 'https://example.com/profiles/daniel.jpg',
      messages: [
        {
          text: "Can we meet tomorrow?",
          type: "incoming",
          timestamp: "2024-08-24T11:00:00",
        },
        {
          text: "Sure, what time?",
          type: "outgoing",
          timestamp: "2024-08-24T11:05:00",
        },
      ],
    },
    {
      user: "Tenant Tim",
      // profilePicture: 'https://example.com/profiles/daniel.jpg',
      messages: [
        {
          text: "Can we meet tomorrow?",
          type: "incoming",
          timestamp: "2024-08-24T11:00:00",
        },
        {
          text: "Ok, what's next?",
          type: "outgoing",
          timestamp: "2024-08-24T11:05:00",
        },
      ],
    },
    {
      user: "Tenant Audrey",
      // profilePicture: 'https://example.com/profiles/daniel.jpg',
      messages: [
        {
          text: "Can we meet tomorrow?",
          type: "incoming",
          timestamp: "2024-08-24T11:00:00",
        },
        {
          text: "No, what room?",
          type: "outgoing",
          timestamp: "2024-08-24T11:05:00",
        },
      ],
    },
    {
      user: "Tenant Kim",
      // profilePicture: 'https://example.com/profiles/daniel.jpg',
      messages: [
        {
          text: "Can we meet tomorrow?",
          type: "incoming",
          timestamp: "2024-08-24T11:00:00",
        },
        {
          text: "Hi, what time?",
          type: "outgoing",
          timestamp: "2024-08-24T11:05:00",
        },
      ],
    },
  ]);

  const handleInputChange = (event) => {
    setMessageInput(event.target.value);
  };

  const handleSendMessage = () => {
    if (messageInput.trim()) {
      const newMessage = {
        text: messageInput,
        type: "outgoing",
        timestamp: new Date().toISOString(),
      };
      const updatedChats = chats.map((chat) =>
        chat.user === activeChat
          ? { ...chat, messages: [...chat.messages, newMessage] }
          : chat
      );
      setChats(updatedChats);
      setMessageInput("");
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };

  const handleChatSelect = (user) => {
    setActiveChat(user);
  };

  const handleBackClick = () => {
    setActiveChat(null); // Go back to chat list
  };

  const currentChat = chats.find((chat) => chat.user === activeChat);

  return (
    <div className="mobile-chat">
      {activeChat ? (
        <>
          <div className="mobile-chat-header">
            <div className="back-button" onClick={handleBackClick}>
              <IoMdArrowBack />
            </div>
            <div className="chat-user">{activeChat}</div>
          </div>

          <div className="mobile-chat-messages">
            {currentChat?.messages.map((message, index) => {
              const showDateSeparator =
                index === 0 ||
                formatDate(message.timestamp) !==
                  formatDate(currentChat.messages[index - 1].timestamp);
              return (
                <React.Fragment key={index}>
                  {showDateSeparator && (
                    <div className="date-separator">
                      {formatDate(message.timestamp)}
                    </div>
                  )}
                  <Message message={message} />
                </React.Fragment>
              );
            })}
          </div>

          <div className="mobile-chat-input-container">
            <input
              type="text"
              className="chat-input"
              placeholder="Type a message..."
              value={messageInput}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
            />
            <button className="send-button" onClick={handleSendMessage}>
              Send
            </button>
          </div>
        </>
      ) : (
        <>
          {" "}
          <TopSection
            setSharedValue={setSharedValue}
            sharedValue={sharedValue}
          />
          <div className="mobile-chat-footer">
            <div className="title-container">Chats</div>
            {chats.map((chat, index) => (
              <ChatItem
                key={index}
                chat={chat}
                isActive={false}
                onSelect={handleChatSelect}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default MobileChat;
